import { cva, cx, type VariantProps } from '@/cva.config';
import { Dialog } from '@base-ui-components/react/dialog';
import type { ReactNode } from 'react';

const backdropVariants = cva({
  base: 'fixed inset-0 z-50 bg-black/50 transition-all duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
  variants: {
    backdrop: {
      default: null,
    },
  },
  defaultVariants: {
    backdrop: 'default',
  },
});

const popupVariants = cva({
  base: 'fixed z-50 overflow-auto rounded-lg bg-white transition-all duration-150 data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0',
  variants: {
    popup: {
      center: 'top-1/2 left-1/2 -translate-1/2',
      pdpConfiguration:
        'top-2 right-2 bottom-2 flex w-full max-w-4/5 flex-col gap-6 rounded-lg md:top-4 md:right-4 md:bottom-4 lg:max-w-145 lg:p-10',
      quickPreview:
        'top-1/2 left-1/2 -translate-1/2 max-h-[calc(100dvh-2rem)] w-4/5 min-w-75 flex-col gap-6 flex max-md:max-w-125 md:max-lg:w-125 lg:w-225 lg:p-8 p-4',
    },
  },
  defaultVariants: {
    popup: 'center',
  },
});

interface ReactModalProps
  extends VariantProps<typeof backdropVariants>,
    VariantProps<typeof popupVariants> {
  backdropClassName?: string;
  children: ReactNode;
  popupClassName?: string;
}

export const ReactModal = ({
  backdrop,
  backdropClassName,
  children,
  popup,
  popupClassName,
}: ReactModalProps) => (
  <Dialog.Portal>
    <Dialog.Backdrop
      className={cx(backdropVariants({ backdrop }), backdropClassName)}
    />
    <Dialog.Popup className={cx(popupVariants({ popup }), popupClassName)}>
      {children}
    </Dialog.Popup>
  </Dialog.Portal>
);
